<template>
  <div class='section'>
    <div class='section-title'>
      <h1>보유차량</h1>
    </div>
    <div class='section-title-underline'></div>
    <div class='section-content'>
      <div class='car-list'>
        <table class='car-table'>
          <tr v-for="column in list" v-bind:key='column'>
            <td v-for="car in column.row" v-bind:key='car'>
              <div class='container-car'>
                <img v-bind:src='car.url'>
                <p>{{car.name}}</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['window'],
  components: {

  },
  mounted () {
      this.list.reverse();
  },
  data() {
    return {
        list: [
          {
            row: [
              { name: '현대 팰리세이드', url: require('@/assets/palisade.png') },
              { name: '제네시스 G80', url: require('@/assets/g80.png') },
              { name: '제네시스 G90', url: require('@/assets/g90.png') },
              { name: '카니발 하이리무진', url: require('@/assets/high-limousin.png') },
            ]
          },
          {
            row: [
              { name: '미니쿠퍼', url: require('@/assets/mini-cuper.png') },
              { name: '폭스바겐 파사트', url: require('@/assets/passat.png') },
              { name: '폭스바겐 아테온', url: require('@/assets/ateon-white.png') },
              { name: '폭스바겐 아테온', url: require('@/assets/ateon-gray.png') },
            ]
          },
          {
            row: [
              { name: '벤츠 C카브리올레', url: require('@/assets/c-cabriolet.png') },
              { name: '벤츠 E카브리올레', url: require('@/assets/e-cabriolet.png') },
              { name: 'BNW Z4', url: require('@/assets/z4.jpeg') },
              { name: '아우디 A6', url: require('@/assets/a6.jpeg') },
            ]
          },
          {
            row: [
              { name: '레인지로버 이보크', url: require('@/assets/evogue.png') },
              { name: '레인지로버 보그', url: require('@/assets/vogue-1.png') },
              { name: '레인지로버 보그', url: require('@/assets/vogue-2.png') },
              { name: '레인지로버 보그', url: require('@/assets/vogue-3.png') },
            ]
          },
          {
            row: [
              { name: '캐딜락 에스컬레이드', url: require('@/assets/escalade-black.png') },
              { name: '캐딜락 에스컬레이드', url: require('@/assets/escalade-white.png') },
              { name: '마세라티 르반떼', url: require('@/assets/levante-black.png') },
              { name: '마세라티 르반떼', url: require('@/assets/levante-white.png') },
            ]
          },
          {
            row: [
              { name: 'BMW 5 시리즈', url: require('@/assets/bmw5-white.png') },
              { name: 'BMW 5 시리즈', url: require('@/assets/bmw5-black.png') },
              { name: '벤츠 E300', url: require('@/assets/e300-white.png') },
              { name: '벤츠 E300', url: require('@/assets/e300-black.png') },
            ]
          },
          {
            row: [
              { name: '마세라티 기블리', url: require('@/assets/ghibli.png') },
              { name: '마세라티 기블리 SQ4', url: require('@/assets/ghibli-sq4.png') },
              { name: '재규어 XJ L', url: require('@/assets/jaguar.png') },
              { name: '벤츠 S350L', url: require('@/assets/s350l.png') },
            ]
          },
          {
            row: [
              { name: '벤츠 S500', url: require('@/assets/s500.png') },
              { name: '벤츠 S560', url: require('@/assets/s560.png') },
              { name: '벤츠 S560 마이바흐', url: require('@/assets/s560-maybach-black.png') },
              { name: '벤츠 S650 마이바흐', url: require('@/assets/s560-maybach.png') },
            ]
          },
          {
            row: [
              { name: '벤틀리 플라잉스퍼', url: require('@/assets/frying-spur.jpeg') },
              { name: '벤틀리 컨티넨탈 GT', url: require('@/assets/bentley-contiental-gt.png') },
              { name: '벤틀리 컨티넨탈 GTC', url: require('@/assets/bentley-contiental-gtc.png') },
              { name: '롤스로이스 고스트', url: require('@/assets/ghost.png') },
            ]
          },
          {
            row: [
              { name: '포르쉐 718 박스터', url: require('@/assets/718-boxter.png') },
              { name: '포르쉐 911 카레라', url: require('@/assets/911-carrera.png') },
              { name: '벤츠 AMG GT', url: require('@/assets/amg-gt.png') },
              { name: '아우디 R8', url: require('@/assets/r8.png') },
            ]
          },
          {
            row: [
              { name: '페라리 캘리포니아 T', url: require('@/assets/california-t.png') },
              { name: '맥라렌 650S', url: require('@/assets/maclaren-650s.png') },
              { name: '람보르기니 우라칸', url: require('@/assets/huracan.png') },
              { name: '람보르기니 아벤타도르', url: require('@/assets/aventador.png') },
            ]
          },
        ]
      }
    }
  }
</script>

<style scoped>
  .section {
    margin-bottom: 3em;
  }
  .section-content {
    margin-top: 4em;
  }
  .car-table {
    text-align: center;
    font-family: s-core5;
    font-size: 2em;
  }
  .car-table p {
    margin: 0;
    word-break: keep-all;
  }
  .car-table td {
    vertical-align: baseline;
    padding: 1em;
  }
  .container-car img{
    width: 100%;
  }

  /* hopper slide */
  .hooper{
    height: auto !important;
    margin-top: 4em;
  }
  .hooper img{
    width: 100%;
  }
  /* mobile */
  @media (max-width: 710px){
    .car-table {
      font-size: 1.2em;
    }
  }
</style>
